import React from 'react'
import { Link } from 'react-router-dom'
import checkForAttributeMapping from '../../functions/checkForAttributeMapping'
import getOtherFilters from '../../functions/getOtherFilters'
import removeItemFromArray from '../../functions/removeItemFromArray'
import Translation from '../../General/Translation'

const ActiveFilters = ({activeFiltersWithoutTime, filterStrings, filters, translation}) => {
    const activeFiltersListItems = Object.keys(activeFiltersWithoutTime).map((filterId, index) => {
        if('id' === filterId) {
            return ''
        }

        const otherFilters = _.omit(filterStrings, filterId)
        const filterValues = activeFiltersWithoutTime[filterId]
        const filterStringWithEqualSign = filterId + '='


        return filterValues.map((filterValue, index) => {
            const copyFilterValues = removeItemFromArray(filterValues.slice(), filterValue)
            let sortValue
            
            if(0 === copyFilterValues.length) {
                sortValue = null 
            } else {
                sortValue = '?' + filterStringWithEqualSign + copyFilterValues.join('&' + filterStringWithEqualSign)
            }
            
            sortValue = getOtherFilters(otherFilters, sortValue)

            let title = ''

            if('search' === filterId) {
                title = <Translation id="search" trans={translation} after={`: "${filterValue}"`}/>
            } else {
                title = checkForAttributeMapping(filters[filterId].items[filterValue].name, translation)
            }
 
            return (
                <li key={index} className="accent-color-border">
                    <span className="overview-filter-title text-bold">{title}</span>
                    <Link className="overfiew-filter-active-remove" to={{search: sortValue}}>
                        <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
                            <polygon className="cls-1" points="25 1.06 23.94 0 12.5 11.44 1.06 0 0 1.06 11.44 12.5 0 23.94 1.06 25 12.5 13.56 23.94 25 25 23.94 13.56 12.5 25 1.06"/>
                        </svg>
                        <span className="screen-reader-text"><Translation id="removeFilters" trans={translation}>Filter entfernen</Translation></span>
                    </Link>
                </li>
            )
        })
    })

    return (
        activeFiltersListItems.length !== 0 && <ul className="overview-filter-active">
            {activeFiltersListItems}
        </ul>
    )
}

export default ActiveFilters